export const splitErrors = <T>(promises: PromiseSettledResult<T>[]) => {
	const ok: T[] = [];
	const err: unknown[] = [];

	for (const promise of promises) {
		if (promise.status == "rejected") {
			err.push(promise.reason);
			continue;
		}

		ok.push(promise.value);
	}

	return { ok, err };
};
